<app-breadcrumb [links]="[{link: 'noticias', name: 'Noticias'}]" [current]="item.titulo"></app-breadcrumb>
<div class="backgroundColor shark lighten-1">
  <section class="container-fluid backgroundColor shark lighten-1 position-relative top-119" id="my-element">
    <div class="container">
      <div class="row pt-48">
        <div class="col-12 col-md-12 col-lg-6">
          <div class="row pb-20">
            <div class="col-12 col-md-6 col-lg-11 col-xl-10 mx-auto">
              <div class="col-12 col-md-12 col-lg-12">
                <div class="card model-border" id="padding-right">
                  <img src="https://{{apiUrl}}/api/news/image/{{item.id}}/{{master}}" class="img-fluid my-5" alt="...">
                  <div class="card-body mb-3">
                    <div class="row col-12 col-lg-12 padd-right-none">
                      <ng-container *ngFor="let row of media; let i = index">
                        <div class="col-3 col-md-3 col-lg-3 padd-right-none" *ngFor="let col of row; let j = index">
                          <img src="https://{{apiUrl}}/api/news/image/{{item.id}}/{{col}}" class="img-thumbnail thumbnail-border img-expand" alt="..." (click)="swapImage(i,j)">
                        </div>
                      </ng-container>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-12 col-md-12 col-lg-5 col-xl-5">
          <div class="col-12  backgroundColor light-mine-shaft base py-3 model-border news-height">
            <h1 class="textColor harvest-gold base font-italic">{{item.titulo}}</h1>
            <hr class="backgroundColor amber base">
            <p class="text-white text-justify">{{item.body}}</p>
            <hr class="backgroundColor amber base">
          </div>
        </div>
      </div>
    </div>
  </section>
</div>
